import { render, staticRenderFns } from "./GenericSelect.vue?vue&type=template&id=80efa01a&scoped=true&"
import script from "./GenericSelect.vue?vue&type=script&lang=js&"
export * from "./GenericSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80efa01a",
  null
  
)

export default component.exports